<template>
  <div class="transitional_page">
    <img :src="shareImg" alt class="shareImg" />
    <div class="now_apply" @click="goSharePage">立即申请</div>
  </div>
</template>
<script>
  import config from '../../../config/index';
  import {
    wx_countForward
  } from '../../../api/api-config';
  const url = config.baseUrl;
  const env = config.Domain;
  import wx from 'weixin-js-sdk';
  export default {
    name: "transitionalpage",
    data() {
      return {
        shareImg: "https://cache.galaxy-immi.com/WeChat/img/img@2x.jpg",
        params: {
          adduser: "",
          client_id: "",
          from: "",
          sign: ""
        }
      };
    },
    mounted() {},
    created() {
      this.params = {
        adduser: this._getUrlParam("adduser"),
        client_id: this._getUrlParam("client_id"),
        from: this._getUrlParam("from"),
        sign: this._getUrlParam("sign")
      };
      this.wxShowMenu()
    },
    methods: {
      goSharePage() {
        this.$router.push(
          `/peelPage?adduser=${this.params.adduser}&client_id=${
          this.params.client_id
        }&from=${this.params.from}&sign=${this.params.sign}`
        );
      },
      _getUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURI(r[2]);
        return null;
      },
      wxShowMenu() {
        this.$http.get(`${url}wechat/getsignature?url=` + encodeURIComponent(window.location.href)).then(function (res) {
          var getMsg = res.data.data
          wx.config({
            debug: false, //生产环境需要关闭debug模式
            appId: getMsg.appid, //appId通过微信服务号后台查看
            timestamp: getMsg.timestamp, //生成签名的时间戳
            nonceStr: getMsg.noncestr, //生成签名的随机字符串
            signature: getMsg.signature, //签名
            jsApiList: [ //需要调用的JS接口列表
              'onMenuShareTimeline', //分享给好友
              'onMenuShareAppMessage', //分享到朋友圈
              'showMenuItems',
              'hideMenuItems'
            ]
          });
          wx.ready(function () {
            var obj = {
              title: "【推荐有礼】亲友同行，福利共享",
              desc: "推荐有礼  申请香港身份，最高享5500元优惠；银河集团2021新春嘉年华“荐者有礼”一起开启人生好局！",
              link: window.location.href,
              imgUrl: "http://wxapi.galaxy-immi.com/img/backend/activity/1606719600_file_370.png",
              success: function (resp) {

              },
              // 整个分享过程结束
              all: function (resp) {

              }
            };
            // 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
            wx.onMenuShareAppMessage(obj);

            // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
            wx.onMenuShareTimeline(obj);

            // 2.3 监听“分享到QQ”按钮点击、自定义分享内容及分享结果接口
            wx.onMenuShareQQ(obj);

            // 2.4 监听“分享到微博”按钮点击、自定义分享内容及分享结果接口
            wx.onMenuShareWeibo(obj);

            // 2.5 监听“分享到QZone”按钮点击、自定义分享内容及分享接口
            wx.onMenuShareQZone(obj);

          });
        })
      }
    }
  };
</script>

<style lang="scss" scoped>
  .transitional_page {
    width: 100%;
    height: 100vh;
    position: relative;

    .shareImg {
      width: 100%;
      height: 100%;
    }

    .now_apply {
      width: rem(330);
      height: rem(68);
      line-height: rem(68);
      background: #ffffff;
      border-radius: rem(34);
      font-size: rem(36);
      font-weight: bold;
      color: #007afe;
      text-align: center;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 7.85%;
    }
  }
</style>